/**
 * PROPRIETARY AND CONFIDENTIAL
 * Copyright (c) 2026 Steven Warehouse Project. All Rights Reserved.
 * Unauthorized copying or distribution is strictly prohibited.
 */

interface LoadingSpinnerProps {
  size?: 'sm' | 'md' | 'lg';
}

export default function LoadingSpinner({ size = 'md' }: LoadingSpinnerProps) {
  const sizeClasses = {
    sm: 'w-5 h-5 border-2',
    md: 'w-8 h-8 border-2',
    lg: 'w-12 h-12 border-3',
  };

  return (
    <div className="flex items-center justify-center">
      <div
        className={`
          ${sizeClasses[size]}
          border-surface-700 border-t-primary-500/80
          rounded-full animate-spin
        `}
      />
    </div>
  );
}
